import withPagination from '@package/components/Views/withPagination';
/* eslint-disable-next-line import/no-unresolved */
import TabularViewOrig from '@plone/volto-original/components/theme/View/TabularView';

export default withPagination(TabularViewOrig);
